<template>
  <div class="media-data">
    <a-button class="add-btn" type="primary" @click="addClick">导入</a-button>
    <a-input-search class="input-search" v-model="searchKeyWord" placeholder="请输入文件名称" @search="search" />
		<div class="page-table">
      <vxe-grid
        border="inner"
        :columns="columns"
        auto-resize
        :column-config="{resizable: true}"
        :row-config="{isCurrent: true, isHover: true}"
        :data="data"
        show-overflow
        :empty-render="{name: 'NotData'}"
        size="small"
        :loading="loading"
			>
      </vxe-grid>
      <a-pagination
        class="mt-16 mb-16 df-end"
        size="small"
        v-if="(data &&data.length > 0)"
        :pageSize="pagination.pageSize"
        :total="pagination.total"
        :current="pagination.current"
        @change="(page, pageSize) => handleTableChange(page,pageSize)"
      />
    </div>
    <a-modal
      :centered="true"
      title="导入数据"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      width="600px"
    >
    <div class="import-template-date" v-if="code == 'FB-AE'">
      <label>日期</label> <a-date-picker valueFormat="YYYYMMDD" v-model="attach" :allowClear="false"/><span class="desc">(请选择导入的数据是哪个日期的)</span><br>
    </div>
      <a-upload class="import-template-upload"
        name="file"  :file-list="fileList" :multiple="true"  :before-upload="beforeUpload"
        accept=".xlsx,.xls,.csv" :remove="handleRemove"
      >
        <a-button v-if="!fileList.length"> <a-icon type="upload" /> 选择文件 </a-button>
      </a-upload>
      <a-button type="link" style="vertical-align: top;" @click="downloadTemplate">下载模板</a-button>
    </a-modal>
  </div>
</template>
<script>
import { getFileList, uploadDataFile, downloadTemplate } from "@/api/mediadata"
import addFieldsModal from "./addFieldsModal"

const columns = [
  { type: 'seq', title: '序号',width: 55 },
  {
		title: '文件名称',
		field: 'fileName',
		// width: 260,
    ellipsis: true,
		align: 'left',
	},
  {
		title: '上传人',
		field: 'creator',
		align: 'left',
		// width: 180,
	},
	{
		title: '上传日期',
		field: 'createTime',
		align: 'left',
		// width: 180,
	},
]
export default {
	name: 'MediaDataExport',
	data() {
		return {
			loading: false,
      searchKeyWord: '',
			pagination: {
				current: 1,
				total: 0,
				pageSize: 10,
        showTotal: total => `共${total}条`
			},
			data: [],
			columns,
      visible: false,
      confirmLoading: false,
      fileList: [],
      attach: null
		}
	},
  props: ['code'],
  methods: {
    handleRemove(file) {
      this.fileList = [];
    },
    addClick() {
      this.visible = true
    },
    editClick(record) {
      this.$refs.addModal.init(record)
    },
    search(value) {
      this.pagination.current = 1
      this.getList()
    },
    getList() {
      this.loading = true
      getFileList({
        type: this.code,
        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current,
        fileName: this.searchKeyWord
      }).then((res) => {
        this.data = res.data.recordList || []
        this.pagination.total = res.data.recordCount
      }).finally(() => this.loading = false)
    },
    handleTableChange(page, filters, sorter) {
      const pager = { ...this.pagination, current:page };
			this.pagination = pager;
			this.getList()
		},
    async downloadTemplate() {
      const file = await downloadTemplate(this.code)
			this.$CreatDownload(file, `模板.${this.code === 'META-ADJUST-TRIP'?'csv':'xlsx'}`)
    },
    handleOk(e) {
      if(!this.fileList[0]) {
        this.$message.error('请上传文件！');
        return
      }
      if(this.code == 'FB-AE'&&!this.attach) {
        this.$message.error('请选择日期！');
        return
      }
      this.confirmLoading = true;
      let params = new FormData()       // 创建form对象     
      params.append('file', this.fileList[0])
      params.append('attach', this.attach)
      uploadDataFile(params, this.code).then((res) => {
        this.$message.success('上传成功！')
        this.fileList = [];
        this.visible = false
        this.pagination.current = 1
        this.getList()
      }).finally(() => this.confirmLoading = false)
    },
    handleCancel(e) {      
      this.visible = false;
      this.fileList = [];
    },
    beforeUpload(file) {
      this.fileList = [file];
      return false;
    },
  },
  mounted() {
    this.getList()
  },
  components: {
    addFieldsModal
  }
}
</script>
<style lang="less" scoped>
.media-data {
  position: relative;
  .frequency-prompt {
		padding-left: 20px;
		padding-bottom: 10px;
	}
  .input-search {
    width: 258px;
    top: -53px;
    position: absolute;
    right: 24px;
  }
  .add-btn {
    position: absolute;
    top: -53px;
    right: 302px;
  }
  .edit-btn {
		margin-right: 16px;
	}
	.delete-btn,.copy-btn, .edit-btn {
		cursor: pointer;
		font-size: 16px;
		vertical-align: middle;
	}
  .define-tag {
    color: #2A6CED;
    transform: scale(0.7, 0.7);
    vertical-align: top;
    position: absolute;
    right: 0;
    top: -3px;
    margin-right: 0;
  }
}
</style>
<style lang="less">
  .error-message {
    white-space: pre-line;
    font-size: 14px;
    font-weight: 400;
    color: #2D3446;
    line-height: 22px;
  }
  .import-template-date {
    margin-bottom: 20px;
    label {
      margin-right: 10px;
    }
    .desc {
      margin-left: 10px;
    }
  }
  .import-template-upload {
    display: inline-block;
    margin-bottom: 20px;
    .ant-upload-list  {
      display: inline-block;
      .ant-upload-list-item {
        margin-top: 4px;
        .ant-upload-list-item-info {
          padding-right: 24px;
        }
      }
    }
  }
</style>